<template>
  <div class="create-file-wrap">
    <CommonHead title="新生儿预建档"></CommonHead>
    <van-tabs v-model="activeName" @click="onClick" :before-change="beforeChange">
      <van-tab title="父母信息" name="1" >
        <div class="form-list">
          <van-form class="vanform" ref="firstForm" label-width="120px" input-align="right" @submit="onBasicSubmit">
            <van-field
                v-model="formData.matherName"
                error
                required
                label="母亲姓名"
                placeholder="请输入母亲姓名"
                :error-message="errMsg.matherName"
            />
            <van-field
                v-model="formData.matherPhone"
                error
                required
                label="母亲联系电话"
                name="母亲联系电话"
                placeholder="请输入母亲联系电话"
                :error-message="errMsg.matherPhone"
            />
            <van-field
              v-model="formData.matherIdCard"
              error
              required
              label="母亲证件号码"
              name="母亲证件号码"
              placeholder="请输入母亲证件号码"
              :error-message="errMsg.matherIdCard"
            />
            <van-field v-model="formData.fatherName" label="父亲姓名"  placeholder="请输入父亲姓名"/>
            <van-field v-model="formData.fatherPhone" label="父亲联系电话"  placeholder="请输入父亲联系电话" :error-message="errMsg.fatherPhone"/>
            <van-field v-model="formData.fatherIdCard" label="父亲证件号码"  placeholder="请输入父亲证件号码" :error-message="errMsg.fatherIdCard"/>
            <van-field name="registeredType" required label="户口类别" :error-message="errMsg.registeredType"  >
              <template #input>
                <div class="card-input" @click="showRegistered = true">
                  <div :class="{grayColor:registeredName == ''}"> {{ registeredName || '请选择户口类别' }} </div>
                  <van-icon name="arrow" color="#999" />

                </div>
              </template>
            </van-field>
            <van-field name="residentialTypeCode" required label="居住属性" :error-message="errMsg.residentialTypeCode" >
              <template #input>
                <div class="card-input" @click="showliveAddress = true">
                  <div :class="{grayColor:resideName == ''}"> {{ resideName || '请选择居住属性' }} </div>
                  <van-icon name="arrow" color="#999" />
                </div>
              </template>
            </van-field>
            <van-field :name="formData.liveDistrictCode" error required label="所在地区" :error-message="errMsg.liveDistrictCode" >
              <template #input>
                <div class="card-input" @click="showArea = true">
                  <div :class="{grayColor:liveDistrictCodeName == ''}"> {{ liveDistrictCodeName || '请选择所在地区' }} </div>
                  <img src="@/assets/user/mapaddr.png" class="msgimg" >
                </div>
              </template>
            </van-field>
            <van-field :name="formData.liveCommunityCode" error required label="所在地区街道" :error-message="errMsg.liveCommunityCode" >
              <template #input>
                <div class="card-input" @click="onShowCommunity">
                  <div :class="{grayColor:liveCommunityCodeName == ''}"> {{ liveCommunityCodeName || '请选择所在地区街道' }} </div>
                  <van-icon name="arrow" color="#999" />
                </div>
              </template>
            </van-field>
            <van-field v-model="formData.liveAddress" required label="详细地址" placeholder="请输入详细住址" :error-message="errMsg.liveAddress"  />
            <div class="btn-box">
              <van-button round block type="info" native-type="submit"> 下一步 </van-button>
            </div>
          </van-form>

        </div>
      </van-tab>
      <van-tab title="基础信息" name="2">
        <div class="form-list">
          <van-form class="vanform" label-width="120px" input-align="right" @submit="onSubmit">
            <van-field v-model="formData.povName" label="出生门诊" placeholder="请输入出生门诊" :error-message="errMsg.povName"  />
            <van-field v-model="formData.name" required label=" 姓名" placeholder="请输入姓名" :error-message="errMsg.name" />
            <van-field name="gender" error required label="性别" :error-message="errMsg.gender"  >
              <template #input>
                <van-radio-group v-model="formData.gender" direction="horizontal">
                  <van-radio :name="item.value" v-for="item in allDictList.gender" :key="item.id"> {{ item.title }} </van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field v-model="formData.birthWeight" required label="出生体重" type="digit" placeholder="请输入出生体重/g" :error-message="errMsg.birthWeight"/>
            <van-field name="birthDate" error label="出生日期">
              <template #input>
                <div class="card-input" @click="showDateTime = true">
                  <div :class="{grayColor:formData.birthDate == ''}"> {{ formData.birthDate || '选择出生日期' }} </div>
                  <img src="@/assets/user/date.png" class="dateimg" >
                </div>
              </template>
            </van-field>
            <van-field v-model="formData.parity" error required label="胎次" placeholder="请填写胎次，如1" :error-message="errMsg.parity" />
            <van-field name="nationCode" error required label="民族" :error-message="errMsg.nationCode" >
              <template #input>
                <div class="card-input" @click="showNationCode = true">
                  <div :class="{grayColor:nationName == ''}"> {{nationName || '请选择民族' }} </div>
                  <van-icon name="arrow" color="#999" />
                </div>
              </template>
            </van-field>
            <div class="btn-box">
              <van-button round block type="info" native-type="submit"> 提交 </van-button>
            </div>
          </van-form>

        </div>
      </van-tab>
      <van-tab title="检验信息" name="3">

      </van-tab>
    </van-tabs>

    <van-popup v-model="showArea" round position="bottom">
      <van-area :area-list="areaList" columns-num="4" @confirm="onConfirm" @cancel="showArea = false" />
    </van-popup>
    <!-- 户口类别   -->
    <van-popup v-model="showRegistered" round position="bottom">
      <van-picker
          title="标题"
          show-toolbar
          value-key="title"
          :columns="allDictList.registered_type"
          @confirm="onConfirmOptions"
          @cancel="showRegistered = false"
      />
    </van-popup>
    <!-- 居住属性   -->
    <van-popup v-model="showliveAddress" round position="bottom">
      <van-picker
          title="标题"
          show-toolbar
          value-key="title"
          :columns="allDictList.reside"
          @confirm="onConfirmLive"
          @cancel="showliveAddress = false"
      />
    </van-popup>
    <!-- 民族   -->
    <van-popup v-model="showNationCode" round position="bottom">
      <van-picker
          title="标题"
          show-toolbar
          value-key="title"
          :columns="allDictList.natian"
          @confirm="onConfirmNationCode"
          @cancel="showNationCode = false"
      />
    </van-popup>
    <!-- 街道   -->
    <van-popup v-model="showCommunity" round position="bottom">
      <van-picker
          title="标题"
          show-toolbar
          value-key="name"
          :columns="regionData"
          @confirm="onConfirmCommunity"
          @cancel="showCommunity = false"
      />
    </van-popup>

    <van-popup v-model="showDateTime" round position="bottom">
      <van-datetime-picker
          v-model="formData.birthDate"
          type="date"
          title="选择日期"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="confirmDate"
          @cancel="showDateTime = false"
      />
    </van-popup>


    <div class="fill-iphone-safe-area"></div>
  </div>
</template>

<script>
import CommonHead from "components/CommonHead";
import { areaList } from '@vant/area-data'
import { Toast } from "vant";
import { getDictList,getSimpleRegion } from '@/api/admin'
import {fetchFamily, getSaveChildCard} from "api/user";
import moment from 'moment'
export default {
  name: 'createFile',
  components: {
    CommonHead
  },
  data() {
    return {
      areaList,
      activeName: '1',
      nextStep: false,
      showArea: false,
      formData: {
        matherName: '', // 母亲姓名
        matherPhone: '' , // 母亲电话
        matherIdCard: '', // 母亲身份证
        fatherName: '', // 父亲姓名
        fatherPhone: '', // 父亲电话
        fatherIdCard: '', // 父亲身份证
        registeredType: '', // 户口类型
        residentialTypeCode: '', // 居住属性
        liveProvCode: '', // 省
        liveCityCode: '', // 市
        liveDistrictCode: '', // 区
        liveCommunityCode: '', // 四级乡镇街道
        liveAddress: '', // 居住地址详细
        birthHospitalCode: '', // 出生医院code
        povName: '', // 门诊
        povCode: '', //
        name: '', // 姓名
        gender: '', // 性别
        birthWeight: '', // 出生体重
        birthDate: '' ,// 出生日期
        parity: '', // 胎次
        nationCode: '',
      },
      errMsg:{
        matherName:'',
        matherPhone: '',
        matherIdCard:'',
        registeredType: '',
        residentialTypeCode: '',
        liveDistrictCode: '',
        liveCommunityCode: '',
        liveAddress: '',
        name: '',
        gender: '',
        birthWeight: '',
        parity: '',
        nationCode: '',
        fatherIdCard: '',
        fatherPhone: ''
      },
      showRegistered: false,  // 户口类别
      showliveAddress: false, // 居住属性
      minDate: '',
      maxDate: new Date(),
      showDateTime: false , // 选择时间
      allDictList: {}, // 字典
      showNationCode: false, // 民族
      nationName: '', // 民族名称
      registeredName: '', // 户口类别名称
      resideName: '', // 居住名称
      regionData: [],
      liveDistrictCodeName: '', // 所在地区名称
      liveCommunityCodeName: '' , // 街道名称
      showCommunity: false, // 显示街道
    }
  },
  created() {
    this.minDate = new Date(moment().format("YYYY-01-01"));
    this.formData.birthDate = moment().format('YYYY-MM-DD');
    this.formData.birthHospitalCode = this.$route.query.povCode;
    // this.formData.matherName = this.$route.query.name;
    this.formData.povName = this.$route.query.povName;
    this.formData.birthHospitalCode = this.$route.query.birthHospitalCode;
    this.getDictList();
  },
  watch: {
    'formData.matherName':{
      deep:true,
      handler:function(newVal,oldVal){
        console.log('watch中：',newVal)
        if (newVal) {
          this.formData.name = this.formData.matherName + '之子/之女';
        }
      }
    }
  },
  methods: {
    async getDictList() {
      const typeList = ['natian', 'registered_type', 'gender', 'card_type', 'occupation','reside']
      const { code, data } = await getDictList(typeList)
      if (code === 0) {
        this.allDictList = data
      }
    },
    onClick(name, title) {
      if (!this.nextStep) {
        return
      }
    },
    beforeChange(name) {
      if (name == 2) {
        if (!this.nextStep) {
          Toast('请填写完整父母信息');
          return
        }
      }
      if (name == 3) {
        Toast('暂未开放');
        return;
      }
      this.activeName = name;
    },
    onConfirm(e) {
      console.log(e,"----地址")
      this.formData.liveProvCode = e[0].code;
      this.formData.liveCityCode = e[1].code;
      this.formData.liveDistrictCode = e[2].code;
      this.liveDistrictCodeName = e[0].name + '/' + e[1].name + '/' + e[2].name;
      if (this.formData.liveDistrictCode) {
        this.getRegionList(this.formData.liveDistrictCode,5);
      }
      this.showArea = false;
    },
    onShowCommunity() {
      if (!this.formData.liveDistrictCode) {
        Toast('请先选择所在地区');
        return
      }
      this.showCommunity = true;
    },
    // 街道
    onConfirmCommunity(e) {
      console.log(e,"----")
      this.formData.liveCommunityCode = e.regionCode;
      this.liveCommunityCodeName = e.name;
      this.showCommunity = false;
    },
    // 户口类别
    onConfirmOptions(e) {
      this.formData.registeredType = e.value;
      this.registeredName = e.title;
      this.showRegistered = false;
    },
    //  选择居住属性
    onConfirmLive(e) {
      this.formData.residentialTypeCode = e.value;
      this.resideName = e.title;
      this.showliveAddress = false;
    },
    // 基本信息提交
    onBasicSubmit() {
      if (!this.formData.matherName) {
        this.errMsg.matherName = '请输入母亲姓名';
        return
      } else {
        this.errMsg.matherName = '';
      }
      if (!this.formData.matherPhone) {
        this.errMsg.matherPhone = '请输入母亲电话';
        return
      } else {
        this.errMsg.matherPhone = ''
        // this.validatePhone(this.formData.matherPhone,matherPhone)
      }
      if (!this.formData.matherIdCard) {
        this.errMsg.matherIdCard = '请输入母亲身份号码';
        return
      } else {
        this.errMsg.matherIdCard = '';
        // this.validateIdCard(this.formData.matherIdCard,matherIdCard);
      }
      if (!this.formData.registeredType) {
        this.errMsg.registeredType = '请选择户口类别';
        return
      } else {
        this.errMsg.registeredType = '';
      }
      if (!this.formData.residentialTypeCode) {
        this.errMsg.residentialTypeCode = '请选择居住属性';
        return
      } else {
        this.errMsg.residentialTypeCode = '';
      }
      if (!this.formData.liveDistrictCode) {
        this.errMsg.liveDistrictCode = '请选择地区';
        return
      } else {
        this.errMsg.liveDistrictCode = '';
      }
      if (!this.formData.liveCommunityCode) {
        this.errMsg.liveCommunityCode = '请选择地区所属街道';
        return
      } else {
        this.errMsg.liveCommunityCode = '';
      }
      if (!this.formData.liveAddress) {
        this.errMsg.liveAddress = '请输入详细地址';
        return
      } else {
        this.errMsg.liveAddress = '';
      }
      // if (this.formData.fatherPhone) {
      //   this.validatePhone(this.formData.fatherPhone,fatherPhone)
      // }
      // if (this.formData.fatherIdCard) {
      //   this.validateIdCard(this.formData.fatherIdCard,fatherIdCard);
      // }

      this.nextStep = true;
      this.activeName = '2';
      console.log(this.activeName)
    },
    confirmDate(time) {
      this.formData.birthDate = moment(time).format('YYYY-MM-DD');
      this.showDateTime = false;
    },
    // 选择民族
    onConfirmNationCode(e) {
      this.formData.nationCode = e.value;
      this.nationName = e.title;
      this.showNationCode = false;
    },
    // 提交
    onSubmit() {
      if (!this.formData.name) {
        this.errMsg.name = '请输入姓名';
        return
      } else {
        this.errMsg.name = '';
      }
      if (!this.formData.gender) {
        this.errMsg.gender = '请选择性别';
        return
      } else {
        this.errMsg.gender = '';
      }
      if (!this.formData.birthWeight) {
        this.errMsg.birthWeight = '请输入出生体重';
        return
      } else {
        this.errMsg.birthWeight = '';
      }
      if (!this.formData.parity) {
        this.errMsg.parity = '请输入胎次';
        return
      } else {
        this.errMsg.parity = '';
      }

      if (!this.formData.nationCode) {
        this.errMsg.nationCode = '请选择民族';
        return
      } else {
        this.errMsg.nationCode = '';
      }
      getSaveChildCard(this.formData).then(res => {
        if (res.code == 0) {
          Toast(res.message);
          setTimeout(() => {
            // this.$router.back()
            this.$router.replace({path: '/my-family'})
          },500)
        }
      })
    },
    // 获取地区
    async getRegionList(upCode,level) {
      const { code, data } = await getSimpleRegion({upCode: upCode, level: level});
      if (code === 0) {
        if (data.length != 0) {
          data.forEach(item => {
            if (item.children && item.children.length != 0) {
              item.children = null;
            }
          })
        }
        this.regionData = data
      }
    },
    //身份证校验
    validateIdCard(value,key) {
      var reg=/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if(value.length==15){
        reg=/^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/
      }
      if(value!=null&&value !=''&&!reg.test(value)){
        if (key == 'fatherIdCard') {
          return this.errMsg.fatherIdCard = '请输入正确的身份证'
        }
        if (key == 'matherIdCard'){
          return this.errMsg.matherIdCard = '请输入正确的身份证'
        }
      } else {
        this.errMsg.matherIdCard = '';
        this.errMsg.matherIdCard = '';
      }
    },
    //  手机号验证
    validatePhone(value,key) {
      const reg = /^(1[3|4|5|6|7|8|9])\d{9}$|^0\d{2,3}-?\d{7,8}$/
      if(value && reg.test(value)) {
        this.errMsg.matherPhone = '';
        this.errMsg.fatherPhone = '';
      } else {
        if (key == 'matherPhone') {
          return this.errMsg.matherPhone = '请输入正确的手机号码'
        }
        if (key == 'fatherPhone'){
          return this.errMsg.fatherPhone = '请输入正确的手机号码'
        }
      }
    }

  }
}
</script>
<style lang="less" scoped>
.create-file-wrap {
  width: 100%;
  box-sizing: border-box;

  ::v-deep {
    .van-tab--active {
      color: #50A0FF;
    }
    .van-cell--required::before {
      color: #FB625F;
    }
    //.van-field--error .van-field__control,
    .van-field--error .van-field__control::placeholder ,
    .van-field__control::placeholder {
      color: #999999;
    }
    .van-field__control {
      color: #333333;
    }
    .van-field--disabled .van-field__label {
      color: rgba(0,0,0,0.65);

    }
    .van-tab__pane {
      background-color: #FFFFFF;
    }
    .van-field__error-message {
      color: #ee0a24;
      text-align: right;
    }
  }

  .form-list {
    width: 100%;
    box-sizing: border-box;
    padding: 12px 13px 20px;

    .btn-box {
      margin-top: 50px;
    }
    .card-input {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .msgimg {
        width: 12px;
        height: 16px;
        margin-left: 3px;
      }
      .dateimg {
        width: 18px;
        height: 17px;
        margin-left: 5px;
      }
      .grayColor {
        color: #999999;
      }

    }










  }









}

</style>